import { inject, Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { take } from "rxjs/operators";

export interface CountriesModel {
	id: string;
	type: string;
	attributes: CountryDataModel;
}

interface CountryDataModel {
	e_money: boolean;
	fiat_id: string;
	iso: string;
	name: string;
	numcode: number;
	phonecode: number;
	residence_allowed: boolean;
	ssn_required: boolean;
	usable: boolean;
}

@Injectable({
	providedIn: "root"
})
export class CountriesService {
	private readonly apiCallService = inject(ApicallService);

	private countries$$: BehaviorSubject<CountriesModel[]> = new BehaviorSubject<CountriesModel[]>([]);
	public readonly countries$ = this.countries$$.asObservable();

	public fetchCountries(): void {
		this.apiCallService
			.get("countries", new ApicallOption())
			.pipe(take(1))
			.subscribe({
				next: (countries) => {
					this.countries$$.next(countries);
				}
			});
	}
}
